var exports = {
  "k": "xf0b3b88a--7a6abb--container",
};

module.exports = exports;
